module.exports = __webpack_public_path__ + "img/logo.87f7e9db.svg";